export default __webpack_public_path__ + "static/media/progress-arrow-down.9cc4398f.svg";